import {
  IAnalysisSummaryInfoFieldsFragment,
  IDashboardInstanceFieldsFragment,
} from '../../../utils/apollo/graphqlSchema';
import { useAppDispatch } from '../../../redux/hooks';
import useDashboardUpdateGrid from './grid/useDashboardUpdateGrid';
import { useCallback, useState } from 'react';
import { IGridPosition } from '../../../components/DndGrid';
import { getRowsWithRemovedContent } from './grid/gridUpdaters';
import {
  IDashboardDeleteReportData,
  ModalSliceType,
  openModal,
} from '../../../redux/slices/modal';

/**
 * Delete content from the dashboard
 *
 * @param dashboard - the current dashboard
 */
const useDashboardDeleteContent = (
  dashboard: IDashboardInstanceFieldsFragment,
) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const { saveDashboardGrid } = useDashboardUpdateGrid(dashboard);

  const createDeleteReportHandler = useCallback(
    (position: IGridPosition, analysis: IAnalysisSummaryInfoFieldsFragment) =>
      () => {
        dispatch(
          openModal({
            type: ModalSliceType.DashboardDeleteReport,
            data: {
              analysisId: analysis.id,
              position,
            } satisfies IDashboardDeleteReportData,
          }),
        );
      },
    [dispatch],
  );

  const createDeleteContentHandler = useCallback(
    (position: IGridPosition) => async () => {
      setLoading(true);
      try {
        await saveDashboardGrid(getRowsWithRemovedContent(position));
      } finally {
        setLoading(false);
      }
    },
    [saveDashboardGrid],
  );

  return {
    loading,
    createDeleteReportHandler,
    createDeleteContentHandler,
  };
};

export default useDashboardDeleteContent;
